<template>
    <a-row justify="space-between"
           align="middle">
        <a-col>
            <h3 class="n-c-base n-line-height-1 n-m-0">归档的项目</h3>
        </a-col>
        <a-col>
            <a-button type="primary"
                      :disabled="project.selectedRowKeys.length <= 0"
                      @click="undo">恢复</a-button>
        </a-col>
    </a-row>

    <div class="n-bg-1 n-p-2 n-body-shadow n-mt-2">
        <a-table :dataSource="project.datas"
                 :columns="project.columns"
                 :row-selection="{ fixed: true, selectedRowKeys: project.selectedRowKeys, onChange: onSelectChange }"
                 :bordered="true"
                 :scroll="{ x: 1000 }"
                 :loading="project.loading"
                 :pagination="project.pageInfo"
                 tableLayout="fixed"
                 size="small"
                 @change="tableChange">

            <template #bodyCell="{ column, record }">
                <template v-if="column.dataIndex == 'name'">
                    <a-row align="middle"
                           class="n-pointer"
                           :gutter="[5]">
                        <a-col>
                            <i class="n-icon n-icon-project n-icon-size-20 n-c-base"></i>
                        </a-col>
                        <a-col>{{ record.name }}</a-col>
                    </a-row>
                </template>

                <template v-if="column.dataIndex == 'status'">
                    <a-row align="middle"
                           :gutter="[5]">
                        <a-col>
                            <i class="n-icon n-icon-size-20 c-status"
                               :class="getStatus(record.status).icon"></i>
                        </a-col>
                        <a-col class="n-f-2">{{ getStatus(record.status).title }}</a-col>
                    </a-row>
                </template>
            </template>
        </a-table>
    </div>
</template>
<script >
    import { mapMutations, mapState } from 'vuex';
    import nui from '@/assets/script';

    export default {
        name: 'CompleteProject',
        computed: {
            ...mapState(nui.extendVue.extendState.concat(['windowWidth'])),
        },
        data () {
            return nui.extend(true, {}, nui.extendVue.extendData, {
                project: {
                    loading: false,
                    datas: [],
                    pageInfo: {
                        total: 0,
                        current: 1,
                        pageSize: 10,
                        showSizeChanger: true,
                        size: 'middle'
                    },
                    columns: [
                        {
                            title: '项目名称',
                            dataIndex: 'name',
                            key: 'name',
                            customCell: (record) => {
                                return {
                                    onClick: () => {
                                        this.warning('此项目已归档，将项目恢复后才能查看项目中的任务信息')
                                    }
                                }
                            }
                        },
                        { title: '状态', dataIndex: 'status', key: 'status', width: 90 },
                        { title: '创建人', dataIndex: 'creator', key: 'creator', width: 90 },
                        { title: '创建日期', dataIndex: 'date', key: 'date', width: 90 },
                        // { title: '责任部门', dataIndex: 'dept', key: 'dept', width: 110 }
                    ],
                    selectedRowKeys: []
                },

            })
        },
        methods: nui.extend(true, {}, nui.extendVue.extendMethods, {
            ...mapMutations(nui.extendVue.extendMutations.concat(['setWindowSize'])),

            NMounted () {
                this.getProject()
            },
            /**
            * @description 分页
            */
            tableChange (page) {
                this.project.pageInfo = page;
                this.getProject()
            },
            /**
             * @description 获取项目
             */
            getProject () {
                this.project.loading = true;

                this.request(this.API.completeProjectList, {
                    method: 'post',
                    data: {
                        pageCount: this.project.pageInfo.current,
                        pageSize: this.project.pageInfo.pageSize
                    }
                }).then(res => {
                    if (res.code == this.REQUEST_SUCCESS_CODE) {
                        this.project.datas = res.data.list.map(item => {
                            return {
                                key: item.projectId,
                                id: item.projectId,
                                name: item.projectName,
                                status: item.progressStatus,
                                creator: item.createUserName,
                                date: this.parseUTC(item.createTime),
                                dept: item.deptName || '-'
                            }
                        })

                        this.project.pageInfo.total = res.data.total

                        this.project.loading = false;
                    } else {
                        this.error(res.msg);
                    }
                })
            },
            /**
             * @description 恢复项目
             */
            undo () {
                this.project.loading = true;

                this.request(this.API.undoCompleteProject, {
                    method: 'post',
                    data: this.project.selectedRowKeys
                }).then(res => {
                    if (res.code == this.REQUEST_SUCCESS_CODE_1) {
                        this.success('恢复成功')

                        if (this.project.pageInfo.current > 1 && this.project.datas.length - this.project.selectedRowKeys.length <= 0) {
                            this.project.pageInfo.current -= 1
                        }

                        this.onSelectChange([]);
                        this.getProject()
                    } else {
                        this.error(res.msg)
                    }
                })
            },
            onSelectChange (selectedRowKeys) {
                this.project.selectedRowKeys = selectedRowKeys
            },
            goTask (data) {
                this.$router.push({ name: 'projectTask', query: { id: data.id } })
            }

        }),
        components: {
        },
        ...nui.extendVue.extendLife
    }
</script>
<style lang="scss">
</style>